var map = {
	"./01.jpg": 4272,
	"./02.jpg": 9231,
	"./03.jpg": 9234,
	"./04.jpg": 5793,
	"./05.jpg": 7268,
	"./06.jpg": 9075,
	"./07.jpg": 8022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7497;